import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EditInstructionModal from './EditInstructionModal';
import AddInstructionModal from './AddInstructionModal';
import DeleteConfirmModal from '../DeleteConfirmModal';
import ViewInstructionModal from './ViewInstructionModal';
import '../../style/Instructions.css';

const CATEGORY_OPTIONS = {
    mountainSafety: 'Безопасность в горах',
    fireSafety: 'Пожарная безопасность',
    waterSafety: 'Безопасность на водных объектах',
    citizenSafety: 'Гражданская оборона'
};

const LANGUAGES = ['ru', 'en', 'kk']; // Поддерживаемые языки

const Instructions = () => {
    const [instructions, setInstructions] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedInstruction, setSelectedInstruction] = useState(null);
    const [currentLanguage, setCurrentLanguage] = useState('ru'); // Текущий язык

    useEffect(() => {
        // Fetch instructions based on current language
        axios
            .get(`https://api.alertapp.kz/api/v1/instructions?lang=${currentLanguage}`)
            .then(response => {
                setInstructions(response.data);
            })
            .catch(error => console.error('Error fetching instructions:', error));
    }, [currentLanguage]);

    const handleEditClick = (instruction) => {
        setSelectedInstruction(instruction);
        setIsEditModalOpen(true);
    };

    const handleViewClick = (instruction) => {
        // Fetch the full instruction details (all translations)
        axios
            .get(`https://api.alertapp.kz/api/v1/instructions/${instruction._id}/all-languages`)
            .then(response => {
                setSelectedInstruction(response.data);
                setIsViewModalOpen(true);
            })
            .catch(error => console.error('Error fetching instruction details:', error));
    };

    const handleDeleteClick = (instruction) => {
        setSelectedInstruction(instruction);
        setIsDeleteModalOpen(true);
    };

    const handleDelete = () => {
        axios.delete(`https://api.alertapp.kz/api/v1/instructions/${selectedInstruction._id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            }
        })
            .then(() => {
                setInstructions(instructions.filter(inst => inst._id !== selectedInstruction._id));
                setIsDeleteModalOpen(false);
            })
            .catch(error => console.error('Error deleting instruction:', error));
    };

    const handleUpdate = (updatedInstruction) => {
        setInstructions(instructions.map(inst =>
            inst._id === updatedInstruction._id ? updatedInstruction : inst
        ));
        setIsEditModalOpen(false);
    };

    const handleAdd = (newInstruction) => {
        setInstructions([...instructions, newInstruction]);
        setIsAddModalOpen(false);
    };

    return (
        <div className="instructions-container">
            <div className="language-switcher">
                <label>Выберите язык:</label>
                <select
                    value={currentLanguage}
                    onChange={(e) => setCurrentLanguage(e.target.value)}
                >
                    {LANGUAGES.map(lang => (
                        <option key={lang} value={lang}>{lang.toUpperCase()}</option>
                    ))}
                </select>
            </div>
            <table className="instructions-table">
                <thead>
                <tr>
                    <th>Категория</th>
                    <th>Название памятки</th>
                    <th>Медиа</th>
                    <th>Действия</th>
                </tr>
                </thead>
                <tbody>
                {instructions.map((instruction) => (
                    <tr key={instruction._id || instruction.title}>
                        <td>{CATEGORY_OPTIONS[instruction.categoryType] || instruction.categoryType}</td>
                        <td>{instruction.title}</td>
                        <td>
                            <button className="view-button" onClick={() => handleViewClick(instruction)}>Посмотреть</button>
                        </td>
                        <td>
                            <button
                                className="edit-button"
                                onClick={() => handleEditClick(instruction)}
                            >
                                Редактировать
                            </button>
                            <button
                                className="delete-button"
                                onClick={() => handleDeleteClick(instruction)}
                            >
                                Удалить
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            {isEditModalOpen && (
                <EditInstructionModal
                    instruction={selectedInstruction}
                    onClose={() => setIsEditModalOpen(false)}
                    onUpdate={handleUpdate}
                />
            )}
            {isAddModalOpen && (
                <AddInstructionModal
                    onClose={() => setIsAddModalOpen(false)}
                    onAdd={handleAdd}
                />
            )}
            {isDeleteModalOpen && (
                <DeleteConfirmModal
                    instruction={selectedInstruction}
                    onClose={() => setIsDeleteModalOpen(false)}
                    onConfirm={handleDelete}
                />
            )}
            {isViewModalOpen && (
                <ViewInstructionModal
                    instruction={selectedInstruction}
                    onClose={() => setIsViewModalOpen(false)}
                />
            )}
            <button className="add-button" onClick={() => setIsAddModalOpen(true)}>
                Добавить новую
            </button>
        </div>
    );
};

export default Instructions;
